module.exports = __webpack_public_path__ + "typescript-code-blocks.34Qg3nlF.svg";